import { render } from "./BaseToast.vue?vue&type=template&id=0665f9d6&ts=true"
import script from "./BaseToast.vue?vue&type=script&lang=ts"
export * from "./BaseToast.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__